import { Divider, Grid } from "@mui/material";
import Typography from "components/common/Typography";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";

interface Props {
  title: string;
  snapShot: any;
}

function NumberSet(props: Props) {
  const { title, snapShot } = props;

  const CustomDivider = (
    <Divider
      sx={{
        height: "70px",
        width: "1px",
        backgroundColor: tokens.Border.General.Tertiary
      }}
      orientation="vertical"
    />
  );

  return (
    <>
      <Typography variant={"body1"} showBold color={tokens.Text.General.Secondary} sx={{ marginBottom: "8px" }}>
        {title}
      </Typography>
      <Grid
        sx={{
          height: "86px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-around",
          borderRadius: "12px",
          padding: "4px",
          backgroundColor: tokens.Background.General.Tertiary
        }}
      >
        <Grid
          item
          xs={4}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            borderRadius: "10px",
            padding: "4px",
            height: "100%",
            backgroundColor: colors.Blue.Blue400,
            color: tokens.Text.General.Inverse
          }}
        >
          <Typography variant={"label"} changeVariant={false} sx={{ lineHeight: 1 }}>
            Completed
          </Typography>
          <Typography variant={"h2"} showBold sx={{ lineHeight: 1 }}>
            {snapShot?.completedLast30Days}
          </Typography>
          <Typography variant={"label"} changeVariant={false} sx={{ lineHeight: 1 }}>
            Past 30 Days
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <Typography variant={"h2"} showBold sx={{ lineHeight: 1 }}>
            {snapShot?.active}
          </Typography>
          <Typography variant={"label"} changeVariant={false}>
            Total Active
          </Typography>
        </Grid>
        {CustomDivider}
        <Grid
          item
          xs={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <Typography variant={"h2"} showBold sx={{ lineHeight: 1 }}>
            {snapShot?.overdue}
          </Typography>
          <Typography variant={"label"} changeVariant={false}>
            Overdue
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export default NumberSet;
